import React from "react";
import styles from "./About.module.css";
import {
  FaLightbulb, // For Early Innovators
  FaBuilding, // For Physical Presence
  FaGlobeAmericas, // For Global Reach
  FaGraduationCap, // For School Partnerships
  FaChartLine, // For Experience & Impact
} from "react-icons/fa";

const About = () => {
  const features = [
    {
      title: "Early Innovators",
      content:
        "Pioneers in K-12 STEM education since 2016, introducing hands-on Robotics, Coding, and STEM concepts two years ago.",
      icon: <FaLightbulb />,
    },
    {
      title: "Physical Presence",
      content:
        "STEMx Studios operate in Bangalore with centers in Whitefield, Indiranagar, Pai Layout, Yeshwantpur, and an upcoming location in HSR Layout.",
      icon: <FaBuilding />,
    },
    {
      title: "Global Reach",
      content:
        "Our online STEM programs connect students worldwide, including India, Dubai, USA, Singapore, England, Nepal, South Africa, Canada, and Japan.",
      icon: <FaGlobeAmericas />,
    },
    {
      title: "School Partnerships",
      content:
        "Collaborated with 240+ international schools in Bangalore to offer in-school STEM programs.",
      icon: <FaGraduationCap />,
    },
    {
      icon: <FaChartLine />,
      title: "Experience & Impact",
      content:
        "With 7+ years of experience, STEMx founders make learning fun and impactful by bringing Robotics, Coding, 3D Printing, Electronics, and Drones to life.",
    },
  ];

  return (
    <section className={styles.about}>
      <div className={styles.container}>
        <div className={styles.header} data-aos="fade-up">
          <h2>About STEMx</h2>
          <p>Building the future of STEM education since 2016</p>
        </div>

        <div className={styles.features}>
          {features.map((feature, index) => (
            <div key={index} className={styles.featureCard}>
              <div className={styles.iconWrapper}>{feature.icon}</div>
              <h3 className={styles.featureTitle}>{feature.title}</h3>
              <p className={styles.featureDescription}>{feature.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
